import { render, staticRenderFns } from "./PaymentFormTable.vue?vue&type=template&id=ff0fdf52&"
import script from "./PaymentFormTable.vue?vue&type=script&lang=js&"
export * from "./PaymentFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports